import { INTERNATIONAL_SIZES_ORDER } from 'src/constants/sizes';
import { AlternativeSize } from 'src/types/global-types';

export const sortOptions = (options: AlternativeSize[]) =>
    options.sort(
        (a, b) => INTERNATIONAL_SIZES_ORDER.indexOf(a.sizeLabel) - INTERNATIONAL_SIZES_ORDER.indexOf(b.sizeLabel),
    );
